import React from "react";

const BottomFooter = () => {
  const currentYear = new Date().getFullYear(); // Get the current year dynamically

  return (
    <div className="bg-light-700 bottom-footer py-4"> 
      <div className="container">
        <div className="row text-center text-sm text-muted">
          {/* Left section with inline text */}
          <div className="col-12">
            <p className="mb-0 text-gray-200">
              <span className="mx-2">Conditions of Use & Sale</span>
              <span className="mx-2">Privacy Notice</span>
              <span className="mx-2">Interest-Based Ads</span>
            </p>
          </div>

          {/* Right section */}
          <div className="col-12 text-gray-200 text-center mt-3">
            <p>© 1996-{currentYear}, Amazon.com, Inc. or its affiliates</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BottomFooter;
